import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { SharedModule } from '../../shared/shared.module';
import { HeaderComponent } from './header.component';
import { LangSelectorModule } from './lang-selector/lang-selector.module';
import { NotificationBellModule } from './notification-bell/notification-bell.module';

@NgModule({
  declarations: [HeaderComponent],
  imports: [
    SharedModule,
    MatToolbarModule,
    MatDividerModule,
    MatIconModule,
    MatButtonModule,
    LangSelectorModule,
    NotificationBellModule,
  ],
  exports: [HeaderComponent],
})
export class HeaderModule {}
